import MobilePhotoHeader from '../src/MobilePhotoHeader';
export default MobilePhotoHeader;
